import { RouteConfig } from 'vue-router';

export const instructionRoute: RouteConfig = {
  path: 'instruction',
  component: () =>
    import(
      /* webpackChunkName: "Instruction" */ '@/views/main/PwaInstruction.vue'
    ),
  name: 'instruction'
};
